import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Card from "../../../components/ui/Card/Card";
import {
  getAllCustomers,
  getAllBookings,
  getAllInvoices,
} from "../../../api/api";
import styles from "./Dashboard.module.css";

const Dashboard = () => {
  const navigate = useNavigate();
  const [customerCount, setCustomerCount] = useState(0);
  const [recentBookings, setRecentBookings] = useState([]);
  const [latestInvoices, setLatestInvoices] = useState([]);
  const userRole = localStorage.getItem("adminRole");

  useEffect(() => {
    // Redirect stringers to their own dashboard
    if (userRole === "stringer") {
      navigate("/dashboard/stringer-dashboard");
      return;
    }
    
    fetchCustomerCount();
    fetchRecentBookings();
    if (userRole === "superadmin") {
      fetchLatestInvoices();
    }
  }, [navigate, userRole]);

  const fetchCustomerCount = async () => {
    try {
      const response = await getAllCustomers();
      const uniqueCustomers = new Set(
        response.data.map((customer) => customer.id)
      );
      setCustomerCount(uniqueCustomers.size);
    } catch (error) {
      console.error("Error fetching customers:", error);
    }
  };

  const fetchRecentBookings = async () => {
    try {
      const response = await getAllBookings();
      const allBookings = response.data;
      const latest = allBookings.slice(-3).reverse();
      setRecentBookings(latest);
    } catch (error) {
      console.error("Error fetching bookings:", error);
    }
  };

  const fetchLatestInvoices = async () => {
    try {
      const response = await getAllInvoices();
      const invoices = response.data
        .filter((inv) => inv.invoice_number)
        .slice(0, 3);
      setLatestInvoices(invoices);
    } catch (error) {
      console.error("Error fetching invoices:", error);
    }
  };

  const handleViewBookings = () => {
    navigate("/dashboard/booking-customer");
  };

  const handleViewCustomers = () => {
    navigate("/dashboard/manage-customer");
  };

  const handleViewInvoices = () => {
    navigate("/dashboard/manage-invoices");
  };

  return (
    <div className={styles.dashboardContent}>
      <div className={styles.cardContainer}>
        <Card title="Created Customers">
          <p className={styles.statistic}>{customerCount} Customers</p>
          <button className={styles.viewButton} onClick={handleViewCustomers}>
            View All
          </button>
        </Card>

        <Card title="Recent Bookings">
          <ul>
            {recentBookings.length > 0 ? (
              recentBookings.map((booking) => (
                <li key={booking.booking_id}>
                  <strong>Booking ID:</strong> {booking.booking_id} |{" "}
                  <span className="dirham-symbol">&#xea;</span>{" "}
                  {booking.total_cost}
                </li>
              ))
            ) : (
              <li>No bookings found</li>
            )}
          </ul>
          <button className={styles.viewButton} onClick={handleViewBookings}>
            View All
          </button>
        </Card>
      </div>
      {userRole === "superadmin" && (
        <div className={styles.invoiceWidget}>
          <h3>Latest Invoices</h3>
          <div className={styles.invoiceList}>
            {latestInvoices.length > 0 ? (
              latestInvoices.map((inv) => (
                <div className={styles.invoiceRow} key={inv.invoice_number}>
                  <div>
                    <strong>{inv.invoice_number}</strong> – {inv.customer_name}
                    <br />
                    <span className="dirham-symbol">&#xea;</span> {inv.amount} |{" "}
                    {new Date(inv.transaction_date).toLocaleDateString()}
                  </div>
                </div>
              ))
            ) : (
              <p>No invoices found</p>
            )}
          </div>
          <div style={{ textAlign: "right", marginTop: "10px" }}>
            <button className={styles.viewAllButton} onClick={handleViewInvoices}>
              View All
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Dashboard;
